import palette from 'src/theme/adminTheme/palette';

export default {
  root: {
    color: palette.icon,
    minWidth: 32,
  },
};
